import { NotImplementedView } from "~/src/views/fragments/not-implemented";

export const ForgotPasswordView = () => {
  return <NotImplementedView />;
};
